import { Link, createFileRoute } from '@tanstack/react-router'

import { Logo } from '@droidmap/frontend-ui'
import { Card, CardContent, CardHeader, CardTitle } from '@droidmap/frontend-ui'
import { Button } from '@droidmap/frontend-ui'

export const Route = createFileRoute('/404')({
  component: NotFoundPage,
})

function NotFoundPage() {
  return (
    <div className="bg-bg flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Logo className="mx-auto h-20 w-auto" />
        <div className="mt-8">
          <Card>
            <CardHeader className="text-center">
              <CardTitle className="text-6xl font-bold">404</CardTitle>
            </CardHeader>
            <CardContent className="text-center">
              <p className="text-text/75 mb-6">
                These aren't the droids you're looking for.
              </p>

              <div className="space-y-3">
                <Link to="/">
                  <Button size="wide" variant="default">
                    Go to Home
                  </Button>
                </Link>

                <Button
                  size="wide"
                  variant="outline"
                  onClick={() => window.history.back()}
                >
                  Go Back
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}
